import { ArrowRight } from "lucide-react";
import { LASER_IMAGE, WHATSAPP_URL } from "@/lib/constants";

export default function TransitionSection() {
  return (
    <section
      data-testid="transition-section"
      className="relative py-20 sm:py-28 bg-white border-t border-[var(--buzas-border)]"
    >
      <div className="container-buzas">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* LEFT — macro image */}
          <div className="lg:col-span-5">
            <div
              className="relative overflow-hidden aspect-[4/3] bg-[var(--buzas-navy)]"
              style={{ borderRadius: "18px" }}
              data-testid="transition-image-wrap"
            >
              <img
                src={LASER_IMAGE}
                alt="Detalhe macro de peça metálica cortada a laser"
                className="absolute inset-0 w-full h-full object-cover"
                style={{
                  filter:
                    "grayscale(0.35) contrast(1.1) brightness(0.88) saturate(0.9)",
                }}
              />
              <div
                aria-hidden
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(26,43,86,0.35) 0%, rgba(26,43,86,0.2) 60%, rgba(217,54,54,0.18) 100%)",
                  mixBlendMode: "multiply",
                }}
              />
            </div>
          </div>

          {/* RIGHT — descriptive copy */}
          <div className="lg:col-span-7">
            <h3
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--buzas-navy)] leading-[1.08] tracking-tight"
              data-testid="transition-title"
            >
              Fabricação de componentes metálicos sob projeto.
            </h3>
            <p
              data-testid="transition-copy"
              className="mt-6 text-[17px] sm:text-[18px] text-[var(--buzas-muted)]"
              style={{ lineHeight: 1.8, maxWidth: "54ch" }}
            >
              Fabricação de componentes metálicos para oficinas aeronáuticas,
              hangares e operações de aviação agrícola, com processos
              integrados e controle técnico rigoroso.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6">
              <a
                href="#beneficios"
                data-testid="transition-cta"
                className="inline-flex items-center gap-2 text-[15px] font-bold text-[var(--buzas-red)] hover:text-[var(--buzas-red-dark)] transition-colors group"
              >
                Conheça nossos processos
                <ArrowRight
                  size={16}
                  className="transition-transform group-hover:translate-x-1"
                />
              </a>
              <span className="text-[13px] text-[var(--buzas-muted)]">
                ·  Atendimento B2B industrial
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
